import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import './../../Modal.css';
import { users } from '../../../../apis/backend';
import AutoComplete from '../../../utils/autoComplete/autoComplete';

class AddWaiver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      school: '',
      address: '',
      city: '',
      state: '',
      zipcode: '',
      parentName: '',
      phone: '',
      email: '',
      emergencyContact1: '',
      emergencyContact2: '',
      medicalNotes: '',
      pronouns: '',
      gender: '',
      race: '',
      ethnicity: '',
      reducedLunch: '',
      juvenileJustice: '',
      waiver: 0
    };
  }

  clearState() {
    this.setState({
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      school: '',
      address: '',
      city: '',
      state: '',
      zipcode: '',
      parentName: '',
      phone: '',
      email: '',
      emergencyContact1: '',
      emergencyContact2: '',
      medicalNotes: '',
      pronouns: '',
      gender: '',
      race: '',
      ethnicity: '',
      reducedLunch: '',
      juvenileJustice: '',
      waiver: 0
    });
  }

  async newWaiver() {
    console.log('newWaiver');
    try {
      const dateOfBirth = new Date(this.state.dateOfBirth);
      const userResult = await users
        .post(
          '/newWaiver',
          {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            dateOfBirth,
            phoneNumber: this.state.phone,
            email: this.state.email,
            school: this.state.school,
            address1: this.state.address,
            city: this.state.city,
            state: this.state.state,
            zipcode: this.state.zipcode,
            parentName: this.state.parentName,
            emergencyContact1: this.state.emergencyContact1,
            emergencyContact2: this.state.emergencyContact2,
            medicalNotes: this.state.medicalNotes,
            pronouns: this.state.pronouns,
            gender: this.state.gender,
            race: this.state.race,
            ethnicity: this.state.ethnicity,
            reducedLunch: this.state.reducedLunch.value,
            juvenileJustice: this.state.juvenileJustice.value,
            waiver: this.state.waiver
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => console.log(response));
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    const selectOptions = [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
      { label: 'Unknown/Prefer not to Answer', value: 'Unknown/Prefer not to Answer' }
    ];
    return (
      <div id="addWaiver" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Waiver</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="table-wrapper-scroll-y" style={{ maxHeight: '550px' }}>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Waiver Type
                    </span>
                  </div>
                  <select
                    className="form-control"
                    value={this.state.waiver}
                    onChange={(e) => this.setState({ waiver: e.target.value })}
                  >
                    <option value="0" disabled>
                      Select Waiver Type
                    </option>
                    {this.props.waivers.map((waiver) => (
                      <option value={waiver.id} key={waiver.id}>
                        {waiver.name}
                      </option>
                    ))}
                    {/* <option value="1">Liability Waiver</option> */}
                  </select>
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      First Name
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.firstName}
                    placeholder="First Name"
                    onChange={(e) => this.setState({ firstName: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Last Name
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.lastName}
                    placeholder="Last Name"
                    onChange={(e) => this.setState({ lastName: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Birthdate
                    </span>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.dateOfBirth}
                    placeholder="Last Name"
                    onChange={(e) => this.setState({ dateOfBirth: e.target.value })}
                  />
                </div>
                <AutoComplete
                  isMultiple={false}
                  minSearchLength={3}
                  inputLabel={'School'}
                  csvRoute={'/data/nde-directory.csv'}
                  dataLabel={'SCHOOL NAME'}
                  onOptionSelect={(e) => {
                    this.setState({ school: e });
                  }}
                />
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Address
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.address}
                    placeholder="Street Address"
                    onChange={(e) => this.setState({ address: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      City
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.city}
                    placeholder="City"
                    onChange={(e) => this.setState({ city: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      State
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.state}
                    placeholder="State"
                    onChange={(e) => this.setState({ state: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Zip/Postal Code
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.zipcode}
                    placeholder="Zip/Postal Code"
                    onChange={(e) => this.setState({ zipcode: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Parent/Guardian Name (If Participant is 18 or younger)
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.parentName}
                    placeholder="Parent Name"
                    onChange={(e) => this.setState({ parentName: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Email
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.email}
                    placeholder="Email"
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Phone #
                    </span>
                  </div>
                  <input
                    type="tel"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.phone}
                    placeholder="Phone #"
                    onChange={(e) => this.setState({ phone: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Emergency Contact Name
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.emergencyContact1}
                    placeholder="Emergency Contact Name"
                    onChange={(e) => this.setState({ emergencyContact1: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Emergency Contact Number
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.emergencyContact2}
                    placeholder="Emergency Contact Number"
                    onChange={(e) => this.setState({ emergencyContact2: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Medical Notes
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.medicalNotes}
                    placeholder="Medical Notes"
                    onChange={(e) => this.setState({ medicalNotes: e.target.value })}
                  />
                </div>
                <AutoComplete
                  isMultiple={false}
                  minSearchLength={0}
                  csvRoute={'/data/pronouns.csv'}
                  dataLabel={'Pronoun'}
                  inputLabel={'Pronoun'}
                  onOptionSelect={(e) => {
                    this.setState({ pronouns: e });
                  }}
                />
                <AutoComplete
                  isMultiple={true}
                  minSearchLength={0}
                  csvRoute={'/data/genders.csv'}
                  dataLabel={'Gender'}
                  inputLabel={'Genders'}
                  onOptionSelect={(e) => {
                    this.setState({ gender: e.join(', ') });
                  }}
                />
                <AutoComplete
                  isMultiple={false}
                  minSearchLength={0}
                  csvRoute={'/data/races.csv'}
                  dataLabel={'Race'}
                  inputLabel={'Race'}
                  onOptionSelect={(e) => {
                    this.setState({ race: e });
                  }}
                />
                <AutoComplete
                  isMultiple={true}
                  minSearchLength={0}
                  csvRoute={'/data/ethnicities.csv'}
                  dataLabel={'Ethnicity'}
                  inputLabel={'Ethnicities'}
                  onOptionSelect={(e) => {
                    this.setState({ ethnicity: e.join(', ') });
                  }}
                />
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Free or Reduced Lunch
                    </span>
                  </div>
                  <Select
                    placeholder="select an option"
                    className="multiselector"
                    value={this.state.reducedLunch}
                    options={selectOptions}
                    onChange={(e) => {
                      this.setState({ reducedLunch: e });
                    }}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Juvinile Justice System
                    </span>
                  </div>
                  <Select
                    placeholder="select an option"
                    className="multiselector"
                    value={this.state.juvenileJustice}
                    options={selectOptions}
                    onChange={(e) => {
                      this.setState({ juvenileJustice: e });
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.newWaiver();
                }}
                disabled={
                  !(
                    this.state.waiver !== 0 &&
                    this.state.firstName !== '' &&
                    this.state.lastName !== '' &&
                    this.state.phone !== '' &&
                    this.state.email !== '' &&
                    this.state.dateOfBirth !== ''
                  )
                }
              >
                Add Waiver
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  waivers: state.admin.admin.waivers,
  access: state.admin.admin.access,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {})(AddWaiver);
